import React from "react";

const ButtonOld = (props) => {
  return (
    <>
      <button
        className='btn'
        style={{
          color: "white",
          width: "328px",
          height: "48px",
          backgroundColor: "#137CCE",
          fontWeight: "600",
         
        }}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
        value={props.value}
      >
        {props.text}
      </button>
    </>
  );
};

export default ButtonOld;
